import Button from "@material-ui/core/Button";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import LinearProgress from "@material-ui/core/LinearProgress";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import Assignment from "@material-ui/icons/Assignment";
import * as React from "react";
import { Link } from "react-router-dom";
import {
  ISanitizedCoach,
  ISurveyRespondentResponse,
  ResponseSource,
} from "src/services";
import Component from "../../components/Component";
import MobilePage from "../../components/MobilePage";
import withAxios, { IAxiosProps } from "../../components/withAxios";
import { IRespondentPagePassedDown } from "../RespondentPage";

const styles = (theme: Theme): Record<string, CSSProperties> => ({
  coachName: {
    fontSize: "22px",
  },
});

interface IChooseCoachPageProps {
  collectRespondentName: boolean;
  code: string;
  schoolData:any
}

type IProps = IChooseCoachPageProps &
  IRespondentPagePassedDown &
  IAxiosProps &
  WithStyles<keyof ReturnType<typeof styles>>;

interface IInputInformationState {
  selectedCoachId?: number;
}

export default withStyles(styles)(
  withAxios(
    class ChooseCoachPage extends Component<IProps, IInputInformationState> {
      public readonly state = this.buildState({
        selectedCoachId: undefined,
      });

      public componentDidMount() {
        const { loadSurvey, code } = this.props;
        loadSurvey(code);
      }

      // render for both students and coaches
      public render() {
        const { responseSource, surveyResponse, school, schoolData } = this.props;
        console.log("ssschhhhhhhhdata", schoolData)
        // render error message and link to go to code input
        if (
          surveyResponse !== undefined &&
          !surveyResponse.properAccess.properAccessCode
        ) {
          return (
            <MobilePage
              header={`${school.name}`}
              title="Error"
              subtitle={`${surveyResponse.properAccess.errorMessage}`}
              schoolLogo={school.logo1}
              schoolLogo2={school.logo2}
              schoolName={school.name}
              headerIcon={<Assignment />}
              tagline={school.tagline}
            >
              <Button
                color="primary"
                variant="contained"
                component={Link}
                {...({ to: `/${ResponseSource[responseSource]}` } as any)}
              >
                Enter Code Page
              </Button>
            </MobilePage>
          );
        }

        const sportName = (() => {
          if (
            surveyResponse === undefined ||
            surveyResponse.sport === undefined
          ) {
            return ``;
          } else {
            return `${surveyResponse.sport.name}`;
          }
        })();

        switch (responseSource) {
          case ResponseSource.student:
            return (
              <MobilePage
                header={sportName}
                title= {schoolData?.isAdSurvey
                ? "Select your AD"
                : "Select your teacher"}
                subtitle=""
                schoolLogo={school.logo1}
                schoolLogo2={school.logo2}
                schoolName={school.name}
                headerIcon={<Assignment />}
                tagline={`${school.tagline}`}
              >
                {this.renderCoachSelect()}
              </MobilePage>
            );
          case ResponseSource.coach:
            return (
              <div className="evaluation-great">
              <MobilePage
                header={sportName}
                title="Select your name"
                subtitle="Self-survey is imperative for great leaders."
                schoolLogo={school.logo1}
                schoolLogo2={school.logo2}
                schoolName={school.name}
                headerIcon={<Assignment />}
                tagline={`${school.tagline}`}
              >
                {this.renderCoachSelect()}
              </MobilePage>
              </div>
            );
          case ResponseSource.parent:
            return (
              <div className="evaluation-greatt">
              <MobilePage
                header={sportName}
                title=
                {schoolData?.isAdSurvey
                ? "Select a AD"
                : "Select a teacher"}
                subtitle=""
                schoolLogo={school.logo1}
                schoolLogo2={school.logo2}
                schoolName={school.name}
                headerIcon={<Assignment />}
                tagline={`${school.tagline}`}
              >
                {this.renderCoachSelect()}
              </MobilePage>
              </div>
            );
          default:
            return (
              <span>
                Something is wrong. No respondent type option provided.
              </span>
            );
        }
      }

      private renderCoachSelect() {
        const { surveyResponse, loadingSurvey } = this.props;
        if (surveyResponse === undefined) {
          if (loadingSurvey) {
            return <LinearProgress variant="query" />;
          }
          return <h1>Oops... something went wrong!!</h1>;
        }
        return (
          <div>
            <div>
              {this.renderCoachRadioGroup(surveyResponse)}
              {this.renderButtonOrFinished(surveyResponse)}
            </div>
          </div>
        );
      }

      private renderButtonOrFinished(
        surveyResponse: ISurveyRespondentResponse
      ) {
        const {
          code,
          collectRespondentName,
          responseSource,
          finishedSurveySections,
        } = this.props;
        const { selectedCoachId } = this.state;

        const finished =
          surveyResponse.coaches.filter(
            (c) =>
              !finishedSurveySections.find(
                (fS) => fS.coachId === c.id && fS.code === code
              )
          ).length === 0;
        if (finished) {
          switch (responseSource) {
            case ResponseSource.student:
            case ResponseSource.coach:
            case ResponseSource.parent:
              return <span>Thanks for your feedback</span>;
            default:
              return <span>Oops… something went wrong</span>;
          }
        }

        const responsePath =
          responseSource === ResponseSource.coach
            ? "teacher"
            : ResponseSource[responseSource];

        return (
          <Button
            disabled={selectedCoachId === undefined}
            color="primary"
            variant="contained"
            component={Link}
            {...({
              to: `/${responsePath}/${code}/${selectedCoachId}/${
                collectRespondentName ? "inputNamePage" : "1"
              }`,
            } as any)}
          >
            Select
          </Button>
        );
      }

      private renderCoachRadioGroup(surveyResponse: ISurveyRespondentResponse) {
        const { selectedCoachId } = this.state;
        return (
          <RadioGroup
            aria-label="Gender"
            name="gender1"
            value={selectedCoachId ? selectedCoachId.toString() : undefined}
            onChange={this.selectCoachId}
          >
            {surveyResponse.coaches.map((coach) => this.renderCoach(coach))}
          </RadioGroup>
        );
      }

      private renderCoach(coach: ISanitizedCoach) {
        const { finishedSurveySections, code, classes } = this.props;
        // check if coach is in finished section
        const coachFinished = !!finishedSurveySections.find(
          (fS) => fS.coachId === coach.id && fS.code === code
        );
        return (
          <FormControlLabel
            key={coach.id}
            disabled={coachFinished}
            value={coach.id.toString()}
            control={<Radio />}
            label={<span className={classes.coachName}>{coach.name}</span>}
          />
        );
      }

      private selectCoachId = (e: React.ChangeEvent<{}>, value: string) => {
        // console.log(e.target.value);
        this.setState({
          selectedCoachId: value ? parseInt(value, 10) : undefined,
        });
      };
    }
  )
);



// WEBPACK FOOTER //
// ./src/pages/respondent/ChooseCoachPage.tsx